import * as React from 'react';
import { IESApiClient } from '@serodigital/ies-api-client';

type ManagementClient = {
  client: IESApiClient;
};

const ClientContext = React.createContext<ManagementClient>({ client: null as unknown as any });

export const ManagementClient = ({ children, value }: React.ProviderProps<ManagementClient>) => {
  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
};

export const useManagementClient = () => React.useContext(ClientContext);
